module.exports = __webpack_public_path__ + "img/ann-2.e210a040.png";